
import { format } from 'date-fns';

class ApiSender {

  async saveHistory(endpoint, msisdn, clickId, language, goalId, goalName, landingPageUrl, landingPageName, params) {
    try {
      const date = new Date();
      const formattedDateTime = format(date, "yyyy-MM-dd HH:mm:ssxxx");
      const response = await fetch(process.env.REACT_APP_BASE_URL + endpoint, {
        method: 'POST',
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          msisdn: msisdn,
          campaignId: params?.campaignId !== undefined ? params.campaignId : null,
          affiliateTrackerId: params?.trackerId !== undefined ? params.trackerId : null,
          transactionId: clickId,
          gclid: params?.gclid !== undefined ? params.gclid : null,
          gbraid: params?.gbraid !== undefined ? params.gbraid : null,
          wbraid: params?.wbraid !== undefined ? params.wbraid : null,
          language: language,
          mfId: params?.mf_id !== undefined ? params.mf_id : null,
          mfToken: params?.mfToken !== undefined ? params.mfToken : null,
          affId: params?.affId !== undefined ? params.affId : null,
          pubId: params?.pubId !== undefined ? params.pubId : null,
          conversionDateTime: formattedDateTime,
          conversionGoalId: goalId,
          conversionGoalName: goalName,
          landingPageUrl: landingPageUrl,
          landingPageName: landingPageName,
          p1: params?.p1 !== undefined ? params.p1 : null,
          p2: params?.p2 !== undefined ? params.p2 : null,
          p3: params?.p3 !== undefined ? params.p3 : null,
          p4: params?.p4 !== undefined ? params.p4 : null,
          p5: params?.p5 !== undefined ? params.p5 : null,
          p6: params?.p6 !== undefined ? params.p6 : null,
          p7: params?.p7 !== undefined ? params.p7 : null,
          p8: params?.p8 !== undefined ? params.p8 : null,
          p9: params?.p9 !== undefined ? params.p9 : null,
          p10: params?.p10 !== undefined ? params.p10 : null,
          p11: params?.p11 !== undefined ? params.p11 : null,
          p12: params?.p12 !== undefined ? params.p12 : null,
          p13: params?.p13 !== undefined ? params.p13 : null,
          p14: params?.p14 !== undefined ? params.p14 : null,
          p15: params?.p15 !== undefined ? params.p15 : null
        })
      });
      
      if (response.ok) {
        return { success: true };
      }
      return { success: false };
    }
    catch (error) {
      console.log(error);
      return { success: false };
    }
  }

  async saveGoogleHistory(landingPageUrl, params) {
    try {
      let baseUrl = null;
      let endpoint = null;
      let extraParams = null;
      const isGoogleCampaign = params?.hasOwnProperty("gclid");
      if (isGoogleCampaign) {
        baseUrl = process.env.REACT_APP_GOOGLE_BASE_URL;
        endpoint = "google/visit";
        const list = ["gclid", "gbraid", "wbraid", "campaignId", "conversions", "cost_micros", "cpa", "utm_source", "utm_medium", "utm_campaign",
          "utm_term", "utm_content", "ad_group_id", "ad_group_name", "ad_id", "keyword_id", "keyword_text", "match_type", "clicks", "impressions",
          "ctr", "average_cpc", "conversion_date", "click_date", "geo_location", "device"];
        extraParams = Object.keys(params).reduce((acc, key) => {
          if (!list.includes(key)) {
            acc[key] = params[key];
          }
          return acc;
        }, {});
      }

      if (endpoint === null) {
        return;
      }

      await fetch(baseUrl + endpoint, {
        method: 'POST',
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          gclid: params.gclid,
          gbraid: params.gbraid,
          wbraid: params.wbraid,
          campaign: params.campaignId,
          conversions: params.conversions,
          costMicros: params.cost_micros,
          cpa: params.cpa,
          utmSource: params.utm_source,
          utmMedium: params.utm_medium,
          utmCampaign: params.utm_campaign,
          utmTerm: params.utm_term,
          utmContent: params.utm_content,
          adGroupId: params.ad_group_id,
          adGroupName: params.ad_group_name,
          adId: params.ad_id,
          keywordId: params.keyword_id,
          keywordText: params.keyword_text,
          matchType: params.match_type,
          clicks: params.clicks,
          impressions: params.impressions,
          ctr: params.ctr,
          averageCpc: params.average_cpc,
          conversionDate: params.conversion_date,
          clickDate: params.click_date,
          geoLocation: params.geo_location,
          device: params.device,
          landingPageUrl: landingPageUrl,
          extraParams: JSON.stringify(extraParams)
        })
      });
    }
    catch (error) {
    }
  }
}

export default ApiSender;  